
export {Tooltip,
ClayTooltipProvider} from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$tooltip.js';
import __x__ from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$tooltip.js';export default __x__;